module.exports = __webpack_public_path__ + "prod/1.42.2/img/chain-bigImg.536a2c3c.png";